<template>
  <div
    data-testid="refresh-license"
    class="refresh-license-block app_text_green"
    @click="handleRefreshLicense()"
  >
    <q-icon
      style="font-size: 13px"
      class="uil uil-sync"
    />
    <div class="ibf-gordita-12-m app_text_green update-license-text">Update License Now</div>
  </div>
</template>

<script>
import { dialogPresets } from '@/services/dialogPresets';
import { notify } from '@/services/notify/notify';
import { CONST_NOTIFY } from '@/services/notify/CONST';
import { defineComponent } from 'vue';
import { LicenseAction_Type, useLicense_Action_Refresh_AsyncMutation } from '@/graphql/codegen/generated/graphql';
import { longPolling } from '@/services/PlatfromGQL/longPolling';
import { useMatomo } from '@/services/matomo/matomo.service';

export default defineComponent({
  name: 'RefreshLicense',
  mixins: [notify, dialogPresets],
  props: {
    licenseKey: String,
  },
  emits: ['refresh-license'],
  setup() {
    const matomo = useMatomo();
    const GQL_refreshLicense = useLicense_Action_Refresh_AsyncMutation({});
    return { GQL_refreshLicense, LicenseAction_Type, matomo };
  },
  methods: {
    async handleRefreshLicense() {
      try {
        const refreshLicensePollingId = await this.GQL_refreshLicense.mutate();
        await longPolling.fetch('license_action_asyncResult', refreshLicensePollingId?.data?.license_action_refresh_async).then(resultData => {
          const result = resultData?.data?.license_action_asyncResult?.result;
          if (result?.errorCode === 0 && result?.state === 1) {
            this.toastMessage(this.$t('license.refreshLicenseSuccess'), CONST_NOTIFY.MESSAGE_TYPE.SUCCESS);
          } else {
            if (result?.state === 5) {
              this.$store.commit('settings/setEnteredLicenseKeyValue', this.licenseKey);
            }
            this.dialogPresets.handleLicenseStateInfo(this.openDialog, result, this.licenseKey);
          }
        });
      } catch (error) {
        this.toastMessage(this.$t('license.refreshLicenseFailed'), CONST_NOTIFY.MESSAGE_TYPE.ERROR);
      } finally {
        this.matomo?.trackEvent({
          category: 'License Page',
          action: 'Update License',
        });
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.refresh-license-block {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 160px;
  height: 24px;
  border-radius: 2px;
  padding: 10px 8px 10px 4px;
  transition: 0.2s;

  &.disabled {
    color: $-system-app-grey-76;
    pointer-events: none;

    .update-license-text {
      color: $-system-app-grey-76 !important;
    }
  }

  &:hover {
    background: $-hovers-hover-primary;
  }

  .update-license-text {
    padding-left: 8px;
  }
}
</style>
